import { Feature, Polygon } from "geojson";
import { NormalizedBlock } from "portal/utils/blocks";
import { Properties, Units } from "@turf/helpers";

export const TYPE_BUFFER = "buffer";
export interface BufferRequest {
  features: Feature[];
  index: number;
  properties?: Properties;
  radius: number;
  type: string;
  units: Units;
}

export interface BufferResponse {
  index: number;
  lines: Feature[];
  type: string;
}

export const TYPE_BLOCKIFY = "blockify";
export interface BlockifyRequest {
  blocks: NormalizedBlock[];
  index: number;
  properties?: Properties;
  type: string;
  units: Units;
}

export interface BlockifyResponse {
  blocks: Feature<Polygon>[];
  index: number;
  type: string;
}

export const TYPE_LINEIFY = "lineify";
export interface LineifyRequest {
  blocks: NormalizedBlock[];
  index: number;
  properties?: Properties;
  type: string;
}

export interface LineifyResponse {
  lines: Feature[];
  index: number;
  type: string;
}
